import { FC } from "react";

const MobileTabHeading = ({
  icon: Icon,
  title,
  iconClassName,
}: {
  icon: FC<{ className?: string }>;
  title: string;
  iconClassName?: string;
}) => {
  return (
    <div className="flex gap-x-1">
      <Icon className={iconClassName ?? "text-fds-tertiary"} />
      <p className="headline-sm">{title}</p>
    </div>
  );
};

export default MobileTabHeading;
